import * as React from 'react';
import { useStyles } from '@sravni/react-utils';
import modules_e182d482 from '../styles/Layout.module.less.js';

/**
 * @description Container component.
 *
 * @component
 * @example
 * ```jsx
 * <Container>content</Container>
 * ```
 */
const Layout = React.forwardRef((props, ref) => {
    const { className, children, ...restProps } = props;
    const cx = useStyles(modules_e182d482);
    return (React.createElement("div", { ref: ref, "data-qa": "Layout", className: cx(className, 'container'), ...restProps }, children));
});
Layout.defaultProps = {};
Layout.displayName = 'Layout';

export { Layout };
//# sourceMappingURL=Layout.js.map
